/**
 * @generated SignedSource<<376eab1fe0ad40f24f957b2aac267d0a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type VersionsEditWrapper$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly canEditVersions: {
        readonly canPerform: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "VersionsEditWrapper";
};
export type VersionsEditWrapper$key = {
  readonly " $data"?: VersionsEditWrapper$data;
  readonly " $fragmentSpreads": FragmentRefs<"VersionsEditWrapper">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    }
  ],
  "kind": "Fragment",
  "name": "VersionsEditWrapper",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "key",
              "variableName": "projectKey"
            }
          ],
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jiraProjectByKey",
          "plural": false,
          "selections": [
            {
              "alias": "canEditVersions",
              "args": [
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "MANAGE_VERSIONS"
                }
              ],
              "concreteType": "JiraProjectAction",
              "kind": "LinkedField",
              "name": "action",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "canPerform"
                }
              ],
              "storageKey": "action(type:\"MANAGE_VERSIONS\")"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "0cc1cd938f8a329a8e13c7214b9b9c3e";

export default node;
